import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useNotify } from '../../../../../hooks';
import { messages } from '../messages';
import {
  AgentInput,
  useExecutiveSummaryGeneration,
} from '../useExecutiveSummaryGeneration';

export const useRequestExecutiveSummary = ({
  patientId,
}: {
  patientId: string;
}) => {
  const { formatMessage } = useIntl();
  const [notify] = useNotify();
  const { isGenerating, generateExecutiveSummary } =
    useExecutiveSummaryGeneration({
      patientId,
    });

  const requestExecutiveSummary = useCallback(
    async (agentInput: AgentInput, context: { isRegenerate: boolean }) => {
      if (isGenerating) {
        return;
      }
      try {
        await generateExecutiveSummary(agentInput, {
          isRegenerate: context.isRegenerate,
        });
      } catch (err) {
        console.error(err);
        notify(formatMessage(messages.generateFailure), 'error');
      }
    },
    [generateExecutiveSummary, isGenerating, formatMessage, notify],
  );

  return { requestExecutiveSummary };
};
